import type { IStorageProvider, ModuleStorage } from "./types";

/** @deprecated Use `createStorageProvider` instead. */
export default function createModuleStorage(storageProvider: Storage, rootKey: string): ModuleStorage {
    let root: { [key: string]: unknown };

    try {
        root = JSON.parse(storageProvider.getItem(rootKey) as string) ?? {};
    } catch (e) {
        root = {};
    }

    return {
        _storage: storageProvider,
        persist(key: string, data: unknown[] | { [key: string]: unknown } | boolean) {
            root = { ...root, [key]: data };
            storageProvider.setItem(rootKey, JSON.stringify(root));
        },
        retrieve(key: string): unknown {
            return root[key];
        },
        remove(key: string): void {
            delete root[key];
            storageProvider.setItem(rootKey, JSON.stringify(root));
        },
    };
}

export function createStorageProvider(storage: Storage, makeKey: (key: string) => string): IStorageProvider {
    return {
        __storage: storage,

        get<T>(key: string, defaultValue?: T): T | null {
            const fallbackValue = defaultValue ?? null;

            const raw = storage.getItem(makeKey(key));

            if (raw === null) {
                return fallbackValue;
            }

            try {
                return JSON.parse(raw) as T;
            } catch {
                return fallbackValue;
            }
        },

        set<T>(key: string, value: T): void {
            try {
                storage.setItem(makeKey(key), JSON.stringify(value));
            } catch {
                // storage issue can be ignored
            }
        },
    };
}
